import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreType } from "../../../../../../../redux/store/store";
import { shouldRenderSpecField } from "../../../../../../../redux/reducers/visibilityMatrixesReducer";
import { handleShowErrorMessage } from "../../../../../../../redux/reducers/claimFieldErrorsReducer";
import { updateFirstStepGeneralFields } from "../../../../../../../redux/reducers/claimReducer";
import { Select } from "@nn-design-system/react-component-library";
import SingleLineRightContainer from "../../../../../../../Components/ReportFormTemplate/SingleLineRightContainer";
import { useScrollToTopErrorInput } from "../../../../../../../CustomHooks/useScrollToTopErrorInput";
import SingleLineContainer from "../../../../../../../Components/ReportFormTemplate/SingleLineContainer";
import WholeLineContainer from "../../../../../../../Components/ReportFormTemplate/WholeLineContainer";

const InvolvedAccidentTypeEnumField: React.FC = () => {
   const fieldNameLowerCase = "involvedAccidentTypeEnum";
   const fieldNameUpperCase =
      fieldNameLowerCase.charAt(0).toUpperCase() + fieldNameLowerCase.slice(1);
   const dispatch = useDispatch();

   const fieldValue = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase[fieldNameLowerCase]
   );

   const dependencyValue = useSelector(
      (state: StoreType) =>
         state.claimState.injuryDescriptionModelBase.isInjuryDueCarAccident
   );

   const visibilityMatrixes = useSelector(
      (state: StoreType) => state.visibilityMatrixesState
   );

   const claimFieldErrorsMessages = useSelector(
      (state: StoreType) => state.claimFieldErrorsState
   );

   const ref = React.useRef<HTMLDivElement>(null);
   useScrollToTopErrorInput(ref, fieldNameUpperCase);

   return (
      <SingleLineContainer
         dependencyValue={
            shouldRenderSpecField(
               "GeneralFields",
               fieldNameUpperCase,
               visibilityMatrixes
            ) && dependencyValue
         }
      >
         <div ref={ref}>
            <Select
               labelText="Pojištěná osoba byla účastníkem nehody jako"
               placeholderText="Vyberte z možností"
               value={fieldValue ?? undefined}
               onChange={(e: any) => {
                  dispatch(
                     updateFirstStepGeneralFields({
                        value: e.target.value,
                        field: fieldNameLowerCase,
                     })
                  );
               }}
               options={[
                  { text: "Řidič", value: 0 },
                  { text: "Chodec", value: 1 },
                  { text: "Spolujezdec", value: 2 },
                  { text: "Cyklista", value: 3 },
                  { text: "Jiné", value: 4 },
               ]}
               validationText={handleShowErrorMessage(
                  fieldNameUpperCase,
                  claimFieldErrorsMessages
               )}
            />
         </div>
      </SingleLineContainer>
   );
};

export default InvolvedAccidentTypeEnumField;
